<app-form-input
	[parentForm]="parentForm"

	[disabled]="disabled"
	[value]="reservationMarche.non"

	[label]="step3.getspan22"
	[type]="'radio'"
	[rule]="''"
	[radios]="[
		{
			label: step3.getoui,
			value: 'Oui'
		},
		{
			label: step3.getnon,
			value: 'Non'
		}
	]"
	[name]="getUid() + '_SepAtt_non'"
>
</app-form-input>

<!---->

<app-oui-type-oui-non-reservation-marche
	*ngIf="isReservationMarcheOui()"
	[uid]="getUid()"
	[parentForm]="parentForm"

	[disabled]="disabled"
	[oui]="reservationMarche.oui"
></app-oui-type-oui-non-reservation-marche>
